import { inject } from '@angular/core';
import { Router, CanActivateFn, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { PERMISSIONS, canAccessAdminPanel } from '../auth/permissions';

export const dashboardRedirectGuard: CanActivateFn = async (): Promise<UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.waitForAuthState();
  await authService.waitForClaims();

  if (authService.hasPermission(PERMISSIONS.CASE_QUEUE_MANAGE)) {
    return router.createUrlTree(['/dashboard/allocator']);
  }
  if (
    authService.hasPermission(PERMISSIONS.DASHBOARD_VIEW) ||
    authService.hasPermission(PERMISSIONS.REQUEST_CREATE)
  ) {
    return router.createUrlTree(['/dashboard/a']);
  }
  if (authService.hasPermission(PERMISSIONS.REVIEW_SUBMIT)) {
    return router.createUrlTree(['/dashboard/reviewer']);
  }
  if (authService.hasPermission(PERMISSIONS.CASE_VIEW_ALL)) {
    return router.createUrlTree(['/dashboard/a']);
  }
  if (canAccessAdminPanel(authService)) {
    return router.createUrlTree(['/admin-panel']);
  }
  return router.createUrlTree(['/no-role']);
};
